// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
apiKey: "AIzaSyAwEvt5I55OifKRz0V8TJ2kU8xJiP8yJKs",
  authDomain: "kokebisa.firebaseapp.com",
  projectId: "kokebisa",
  storageBucket: "kokebisa.appspot.com",
  messagingSenderId: "764512040632",
  appId: "1:764512040632:web:8e0fa6b3cefdb3845c664d"
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
